import { render, staticRenderFns } from "./serverping.vue?vue&type=template&id=20dd49e0"
import script from "./serverping.vue?vue&type=script&lang=js"
export * from "./serverping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports